export default {"src":"/_next/static/image/public/images/gift.76676b41ed1249632151ab7e86614a21.svg","height":72,"width":82};